<template lang="html">
  <div class="complementary">
    <v-row>
      <v-col>
        <span class="fiveOrten">{{mainNumber}}</span>
        <v-icon class="shuffleicon" @click="shuffle">mdi-shuffle-variant</v-icon>
      </v-col>
    </v-row>
    <div class="animationcontainer">
      <div class="arrow">
        <v-icon color="darkblue" large>mdi-cursor-default-click</v-icon>
      </div>
      <div class="circle">
      </div>
    </div>
    <v-row justify="center" v-if="numbers">
      <v-col cols="6" sm="4" md="3" v-for="(num,i) in numbers" :key="i">
        <Card :num="num" :baseNumber="mainNumber" :key="i+j"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import gsap from 'gsap'
import Card from './Card.vue'

export default {
  data(){
    return{
      numbers: false,
      j: 0, //for unique card key
    }
  },
  components:{
    Card,
  },
  computed:{
    level(){
      return this.$store.getters['kids/level']
    },
    colnumber(){
      if (this.level==0) {
        return 5
      }
      else{
        return 4
      }
    },
    mainNumber(){
      if (this.level==0) {
        return 5
      }
      else{
        return 10
      }
    }
  },
  methods: {
    getNumberArray(){
      let requiredlength = this.level==0 ? 4 :9;
      let myarray = []
      let min = 1
      let max = this.mainNumber-1

      while (myarray.length<requiredlength) {
        let num = Math.floor(Math.random() * (max - min + 1) ) + min; //min and max both included
        if (!myarray.includes(num)) {
          myarray.push(num)
        }
      }
      return myarray;
    },
    shuffle(){
      this.numbers = false;
      this.numbers = this.getNumberArray();
    },
  },
  watch:{
    level(){
      this.numbers=[]
    },
    numbers(){
      this.j +=1;
    }
  },
  mounted(){
    const tl= gsap.timeline();

    tl.to('.animationcontainer', {duration:0.3, display:"block"})
    tl.to('.animationcontainer .arrow', {duration: 0.8, display:'block'})
    tl.to('.animationcontainer .circle', {duration: 0.5, scale:1.5, boxShadow:'1px 1px 1px 1px #aaa'})
    tl.to('.animationcontainer .circle', {duration: 0.5, scale:1, boxShadow:'none'})
    // tl.to('.animationcontainer .arrow', {duration: 0.2, display:"none"})
    tl.to('.animationcontainer', {duration:0.3, display:"none"})
    tl.to('.shuffleicon', {duration:0.9, scale:1.5})
    tl.to('.shuffleicon', {duration:0.9, scale:1})
  }
}
</script>

<style lang="scss" scoped>
.fiveOrten{
  font-size: 4rem;
}

.mdi-shuffle-variant{
  display: inline-block;
  margin-bottom: 2rem;
  margin-left: 5px;
  color: red;
}


.animationcontainer{
  display: none;
  position: relative;

  .arrow{
    position: absolute;
    display:none;
    z-index: 10;
    top: 10px;
    left: 48%;
  }
  .circle{
    position: absolute;
    left: 47%;
    width: 40px;
    height: 40px;
    background-color: #ccc;
    border-radius: 50%;
  }

}

</style>
